import { Type } from 'lucide-react';
import { z } from 'zod';
import { TextFieldInput, TextFieldView } from '../renderers/fields/text/text-field';
import type { FieldDefinition, TextFieldSchema } from '../types';

export const TextDefinition: FieldDefinition<TextFieldSchema, string | null | undefined> = {
  type: 'text',
  toolboxLabel: 'Text Input',
  category: 'Standard Inputs',
  description: 'A standard single-line text field for short answers.',
  icon: Type,

  createDefault: (id) => ({
    id,
    type: 'text',
    name: `text_${id}`,
    label: 'New Text Field',
    required: false,
    placeholder: 'Enter text...',
  }),

  configSchema: [
    { id: 'label', type: 'text', name: 'label', label: 'Field Label', required: true },
    { id: 'name', type: 'text', name: 'name', label: 'Data Key (ID)', required: true },
    {
      id: 'placeholder',
      type: 'text',
      name: 'placeholder',
      label: 'Placeholder Text',
      required: false,
    },
    {
      id: 'required',
      type: 'checkbox',
      name: 'required',
      label: 'Required Field',
      required: false,
    },
    { id: 'minLength', type: 'number', name: 'minLength', label: 'Min Length', required: false },
    { id: 'maxLength', type: 'number', name: 'maxLength', label: 'Max Length', required: false },
  ],

  buildValidation: (field) => {
    let schema = z.string({ error: `${field.label} is required` });

    if (field.minLength !== undefined) {
      schema = schema.min(
        field.minLength,
        `${field.label} must be at least ${field.minLength} characters`
      );
    }

    if (field.maxLength !== undefined) {
      schema = schema.max(
        field.maxLength,
        `${field.label} cannot exceed ${field.maxLength} characters`
      );
    }

    if (field.required) {
      return schema.min(1, `${field.label} is required`);
    }

    return schema.optional().or(z.literal(''));
  },

  editComponent: TextFieldInput,
  viewComponent: TextFieldView,
};
